import {
    Box,
    Flex,
    Heading,
    Text
} from "@chakra-ui/react";
const PerformanceMetrics = (props) => {
    return (

        <Box mt="40px" fontSize="14px" fontWeight="500">
            <Heading textAlign="center" fontSize="26px" fontWeight="600">Performance Metrics</Heading>

            <Flex my="30px" w="100%" flexDirection={{ base: "column", md: "row" }} wrap="wrap">

                <Box borderRight={{ md: "1px #D9D9D9 solid" }} borderTop="1px #D9D9D9 solid" w={{ md: "50%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Targeted Investor IRR</Heading>
                    <Text fontSize="26px" fontWeight="700">{props.data?.targetedInvestorIRR ? `${props.data?.targetedInvestorIRR}%*` : null}</Text>
                </Box>
                <Box borderTop="1px #D9D9D9 solid" w={{ md: "50%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Targeted Average Cash Yield</Heading>
                    <Text fontSize="26px" fontWeight="700">{props.data?.targetedAverageCashYield ? `${props.data?.targetedAverageCashYield}%*` : null}</Text>
                </Box>
                <Box borderRight={{ md: "1px #D9D9D9 solid" }} borderTop="1px #D9D9D9 solid" w={{ md: "50%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Targeted Equity Multiple</Heading>
                    <Text fontSize="26px" fontWeight="700">{props.data?.targetedEquityMultiple ? `${props.data?.targetedEquityMultiple}x*` : null}</Text>
                </Box>
                <Box borderTop="1px #D9D9D9 solid" w={{ md: "50%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Net Operating Income</Heading>
                    <Text fontSize="26px" fontWeight="700">{props.data?.netOperatingIncome ? `$${props.data?.netOperatingIncome}` : null}</Text>
                </Box>
                <Box borderRight={{ md: "1px #D9D9D9 solid" }} borderTop="1px #D9D9D9 solid" w={{ md: "33.3%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Units</Heading>
                    <Text fontSize="20px" fontWeight="600">{props.data?.units ? `${props.data?.units}` : null}</Text>
                </Box>
                <Box borderRight={{ md: "1px #D9D9D9 solid" }} borderTop="1px #D9D9D9 solid" w={{ md: "33.3%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Target Equity</Heading>
                    <Text fontSize="20px" fontWeight="700">{props.data?.targetEquity ? `$${props.data?.targetEquity}` : null}</Text>
                </Box>
                <Box borderTop="1px #D9D9D9 solid" w={{ md: "33.3%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Year Built</Heading>
                    <Text fontSize="20px" fontWeight="700">{props.data?.yearBuilt ? `${props.data?.yearBuilt}` : null}</Text>
                </Box>
                <Box borderRight={{ md: "1px #D9D9D9 solid" }} borderTop="1px #D9D9D9 solid" w={{ md: "33.3%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Closing Date</Heading>
                    <Text fontSize="20px" fontWeight="700">{props.data?.closingDate ? `${props.data?.closingDate}` : null}</Text>
                </Box>
                <Box borderRight={{ md: "1px #D9D9D9 solid" }} borderTop="1px #D9D9D9 solid" w={{ md: "33.3%" }} textAlign="center" p="0 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Price Per Token</Heading>
                    <Text fontSize="20px" fontWeight="700">{props.data?.pricePerToken ? `$${props.data?.pricePerToken}` : null}</Text>
                </Box>
                <Box borderTop="1px #D9D9D9 solid" w={{ md: "33.3%" }} textAlign="center" p="30 12px 30px">
                    <Heading fontSize="20px" fontWeight="500" mt="30px" mb="8px">Target Period</Heading>
                    <Text fontSize="20px" fontWeight="700">{props.data?.targetPeriod ? `${props.data?.targetPeriod}years*` : null}</Text>
                </Box>



            </Flex>
        </Box>

    );
}

export default PerformanceMetrics;